/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { PolicyList } from "api/legal/models/policies";
import { Enum } from "api/types";
import { globalVar } from "utils/globalVar";
import { NoPolicyDataFound } from "../../api/legal/models/legal";
import { fetchPoliciesByCountryCode } from "../../api/legal/policiesApi";
import BaseLogic from "../../utils/BaseLogic";

interface State {
  isLoading: boolean;
  policies: PolicyList | null;
  error: Error | null;
}

export const PolicyType = Enum("LEGAL_DOCUMENT_TYPE", "MARKETING_PREFERENCE_TYPE");
type PolicyType = keyof typeof PolicyType;

const DEFAULT_COUNTRY_CODE = globalVar.JUSTICE_DEFAULT_COUNTRY_CODE || "US";

export default class PoliciesLogic extends BaseLogic<State> {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      policies: null,
      error: null,
    };
  }

  async init(countryCode = DEFAULT_COUNTRY_CODE, policyType?: PolicyType) {
    await this.fetchPoliciesByCountry(countryCode, policyType);
  }

  async fetchPoliciesByCountry(countryCode: string, policyType?: PolicyType) {
    const { isLoading } = this.state;
    if (isLoading) return;

    this.setState({
      isLoading: true,
      error: null,
    });
    this.setState({ isLoading: true });

    try {
      const { response, error } = await fetchPoliciesByCountryCode(countryCode, true, policyType);
      if (error) throw error;
      if (!response || !response.data.length) throw new NoPolicyDataFound();
      await this.setState({
        policies: response.data,
      });
    } catch (error) {
      await this.setState({ error });
    } finally {
      await this.setState({ isLoading: false });
    }
  }
}
